import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import { UIHideAlert, UIHideConfirm } from '../../../actions/ui';

class UIModals extends Component {
  _renderUIAlert = () => (
    <Modal isOpen={this.props.isAlertVisible}>
      <div className='p-4 text-center'>
        {this.props.alertMessage}
      </div>
      <div className='text-center pb-3'>
        <button className='button button-primary' onClick={this.props.UIHideAlert}>Ok</button>
      </div>
    </Modal>
  );

  confirmAction = () => {
    this.props.UIHideConfirm();
    this.props.confirmAction();
  };

  _renderUIConfirm = () => (
    <Modal isOpen={this.props.isConfirmVisible}>
      <div className='p-4 text-center'>
        {this.props.confirmMessage}
      </div>
      <div className='text-center pb-3'>
        <button className='button button-delete' onClick={this.props.UIHideConfirm}>{this.props.uiProps.cancelButtonLabel}</button>
        <button className='button button-primary ml-3' onClick={this.confirmAction}>{this.props.uiProps.proceedButtonLabel}</button>
      </div>
    </Modal>
  );

  render () {
    return (
      <Fragment>
        {this._renderUIAlert()}
        {this._renderUIConfirm()}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  ...state.ui
});

const mapDispatchToProps = { UIHideAlert, UIHideConfirm };

export default connect(mapStateToProps, mapDispatchToProps)(UIModals);



// WEBPACK FOOTER //
// ./src/components/common/ui/UIModals.js